import request from "@/utils/request";

export function token(data) {
  return request({
    url: "/Authenticate",
    method: "post",
    data,
  });
}

export function me(params) {
  return request({
    url: "/Authenticate",
    method: "get",
    params,
  });
}
